"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ToolbarContainer = void 0;
const react_1 = __importDefault(require("react"));
const Theme_1 = require("../../Theme/Theme");
const ToolbarContainerContainer = Theme_1.styled.div `
  background-color: ${(props) => props.theme.gray5};
  height: ${(props) => props.height || '64px'};
  padding: 0 16px;
  font-family: ${(props) => props.theme.font.family.proximaNova};
`;
exports.ToolbarContainer = (props) => {
    return (react_1.default.createElement(ToolbarContainerContainer, Object.assign({}, props), props.children));
};
//# sourceMappingURL=ToolbarContainer.js.map